let state = {
    user: {},
    userPoints: [],
    userInfo: {},
    qcssoSdk: null,
    isLoggedIn: false,
    loginConfirmShow: false,
    currentPath: "",
    isFinishQuestions: false,
    isQANotExist: false,
    campaign: {},
    muteNotifications: false
};

export default state